import type {ToolUserRequestedMessage} from '../../types/session'
import {isElicitationAskUser} from '@github-ui/copilot-shared-ui/ahp/interactive-prompt-types'
import {isAskUserArguments} from '../../types/session'
import {ResolvedAskUser} from './ResolvedAskUser'

interface AskUserLogEntryProps {
  prompt: ToolUserRequestedMessage
  resolvedAnswer?: string
  isAborted?: boolean
}

/** Renders a resolved ask_user prompt in the session logs timeline. */
export function AskUserLogEntry({prompt, resolvedAnswer, isAborted}: AskUserLogEntryProps) {
  const {arguments: args} = prompt

  if (!isAskUserArguments(args)) {
    return null
  }

  const displayText = isElicitationAskUser(args) ? args.message : args.question
  return <ResolvedAskUser question={displayText} resolvedAnswer={resolvedAnswer} isAborted={isAborted} />
}
